/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A6Inputs */

const en_pc_faq_a6 = /** @type {(inputs: Pc_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The source code is public, Windows installers are code-signed, the Mac app is notarized by Apple, and every release ships a SHA-256 checksum file. The app sends no telemetry.`)
};

const zh_pc_faq_a6 = /** @type {(inputs: Pc_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源代码完全公开，Windows 安装包经过代码签名，Mac 版经过 Apple 公证，每个版本都附带 SHA-256 校验文件。应用不发送任何遥测数据。`)
};

/**
* | output |
* | --- |
* | "The source code is public, Windows installers are code-signed, the Mac app is notarized by Apple, and every release ships a SHA-256 checksum file. The app se..." |
*
* @param {Pc_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a6 = /** @type {((inputs?: Pc_Faq_A6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a6(inputs)
	return zh_pc_faq_a6(inputs)
});
export { pc_faq_a6 as "pc.faq.a6" }